import React, { ReactElement, useContext, useEffect } from 'react';
import { TeApiContext } from '@ecommerce/nest-ssr/common';
import ReactDOM from 'react-dom';

import './category-list-overlay.scss';

const CategoryListOverlay: React.FC<{ onClose: () => void; }> = ({ onClose }): ReactElement | null => {
    const api = useContext(TeApiContext);

    if (api === null) {
        throw new Error('Invalid API context');
    }

    useEffect((): any => {
        if (api.getDevice() === 'mobile') {
            document.body.style.overflow = 'hidden';
        }

        return (): any => {
            if (api.getDevice() === 'mobile') {
                document.body.style.overflow = '';
            }
        };
    }, [api]);

    return ReactDOM.createPortal((
        <div className="category-list-overlay" onClick={onClose} role="none"/>
    ), document.body);
};

export default CategoryListOverlay;
